module.exports = __webpack_public_path__ + "img/down-chevron.a5a38c0e.svg";